<!-- 振替登録画面_振替登録 -->
<form [formGroup]="azukarikinFurikaeSearchConditionForm">
    <app-sgke040d-search-condition [codeConversionMstMap]="codeConversionMstMap"
        (hideEvent)="hideazukarikinFurikaesakiSearched()" (searchEmit)="onSearchFurikaesaki($event)"
        (registNonCisEmit)="onClickRegistNonCis()"></app-sgke040d-search-condition>
</form>

<!-- 振替登録画面_検索結果 -->
<app-sgke040d-search-result [searchResultList]="searchResultList" (registEmit)="onClickRegist($event)"
    *ngIf="searchResultList?.length > 0"></app-sgke040d-search-result>